import { useContext } from 'react';

import { HouseholdWorkflowTrackersContext } from './HouseholdWorkflowTrackersContext.context';

export function useHouseholdWorkflowTrackersContext() {
  const context = useContext(HouseholdWorkflowTrackersContext);
  if (!context) {
    throw new Error(
      'useHouseholdWorkflowTrackersContext must be used within a HouseholdWorkflowTrackersProvider'
    );
  }
  return context;
}
